export default "__VITE_ASSET__CytFbYt5__"